module.exports = __webpack_public_path__ + "img/googleplay.38b485ae.png";